import * as React from "react";
import { TriangleAlert } from "lucide-react";

interface Props {
  children: React.ReactNode;
}

interface State {
  error: Error | null;
}

export class AppErrorBoundary extends React.Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error("Unhandled application error:", error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background px-4 text-center">
          <span className="flex size-14 items-center justify-center rounded-2xl bg-danger-muted text-danger">
            <TriangleAlert className="size-7" />
          </span>
          <div className="flex flex-col gap-1">
            <h1 className="text-lg font-semibold text-foreground">The application hit an unexpected error</h1>
            <p className="max-w-md text-sm text-muted-foreground">{this.state.error.message}</p>
          </div>
          <button
            onClick={() => window.location.assign("/")}
            className="rounded-md bg-brand px-4 py-2 text-sm font-medium text-brand-foreground hover:bg-brand/90"
          >
            Reload OA-Mary
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
